import React from 'react'
import { useNavigate } from 'react-router-dom'
import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import { FleetList } from '../../../features/fleet'

// F2 — top-level fleet list page. Selecting a fleet navigates to its detail.
// Uses the same HeaderTitleContent back-button placement as the detail page
// (and the app's other detail pages) for a consistent "← Retour" above the title.
export default function FleetListPage() {
  const navigate = useNavigate()
  return (
    <div>
      <HeaderTitleContent
        withGoBackBtn
        goBackBtnLabel="Retour"
        onGoBack={() => navigate('/main/setting')}
      >
        Parcs de luminaires
      </HeaderTitleContent>
      <div style={{ padding: '1rem 0' }}>
        <FleetList onSelect={(fleetId) => navigate('/main/setting/fleets/' + fleetId)} />
      </div>
    </div>
  )
}
